import { DSCol, DSRow, DSText } from '@vr/ds-react'

import { BoxContent } from './styled'

export const PanelNumbers = ({
  numbers
}: {
  numbers: { total: number; integrados: number; erro: number }
}) => {
  return (
    <DSRow wrap='wrap' css={{ marginTop: '$sm20' }}>
      <DSCol xs={4} lg={4} css={{ display: 'flex', flexDirection: 'column' }}>
        <BoxContent>
          <DSText size='sm'>TOTAL</DSText>
          <DSText size='lg' weight='bold'>
            {numbers.total}
          </DSText>
        </BoxContent>
      </DSCol>
      <DSCol xs={4} lg={4} css={{ display: 'flex', flexDirection: 'column' }}>
        <BoxContent>
          <DSText size='sm'>INTEGRADOS</DSText>
          <DSText size='lg' weight='bold' color='successDark'>
            {numbers.integrados}
          </DSText>
        </BoxContent>
      </DSCol>
      <DSCol xs={4} lg={4} css={{ display: 'flex', flexDirection: 'column' }}>
        <BoxContent>
          <DSText size='sm'>COM ERRO</DSText>
          <DSText size='lg' weight='bold' color='errorDark'>
            {numbers.erro}
          </DSText>
        </BoxContent>
      </DSCol>
    </DSRow>
  )
}
